import type { EnumUnion } from '@dresscode-frontend/utility-types';

/**
 * 取扱資格一覧のソート可能なカラム
 */
export const HandlingCertificationOrderBy = {
  CERTIFICATION_NAME: 'CERTIFICATION_NAME',
  CERTIFICATION_CODE: 'CERTIFICATION_CODE',
  ISSUING_ORGANIZATION_NAME: 'ISSUING_ORGANIZATION_NAME',
  CERTIFICATIONS_HOLDERS_COUNT: 'CERTIFICATIONS_HOLDERS_COUNT'
} as const satisfies Record<string, string>;
export type HandlingCertificationOrderBy = EnumUnion<typeof HandlingCertificationOrderBy>;

/**
 * テーブルカラムの定義
 */
export const HandlingCertificationTableColumns = {
  handlingCertificationName: 'handlingCertificationName',
  handlingCertificationCode: 'handlingCertificationCode',
  issuingOrganizationName: 'issuingOrganizationName',
  certificationsHoldersCount: 'certificationsHoldersCount'
} as const;
export type HandlingCertificationTableColumns = (typeof HandlingCertificationTableColumns)[keyof typeof HandlingCertificationTableColumns];